function getLocalizedMarketPath() {
  if (!document.body) return "/";
  return (document.body.getAttribute("data-market-path") || "/").trim() || "/";
}

function localizeStorefrontPath(path) {
  var rawPath = String(path || "").trim();
  if (!rawPath) return "/";
  if (
    rawPath.indexOf("://") !== -1 ||
    rawPath.indexOf("mailto:") === 0 ||
    rawPath.indexOf("tel:") === 0 ||
    rawPath === "#" ||
    rawPath === "#!"
  ) {
    return rawPath;
  }

  var marketPath = getLocalizedMarketPath();
  var knownPrefixes = [
    "/en-th",
    "/en-sg",
    "/zh-sg",
    "/en-jp",
    "/ja-jp",
    "/en-my",
    "/en-cn",
    "/zh-cn",
  ];
  knownPrefixes = knownPrefixes.concat(["/en-au", "/zh-hk", "/zh-tw", "/ko-kr"]);

  for (var index = 0; index < knownPrefixes.length; index += 1) {
    var prefix = knownPrefixes[index];
    if (rawPath === prefix || rawPath.indexOf(prefix + "/") === 0)
      return rawPath;
  }

  if (rawPath.charAt(0) !== "/") rawPath = "/" + rawPath;

  if (marketPath === "/" || marketPath === "") return rawPath;
  if (rawPath === "/") return marketPath;

  return marketPath + rawPath;
}

window.localizeStorefrontPath = localizeStorefrontPath;

document.addEventListener("DOMContentLoaded", function () {
  if (window.Shopify && window.Shopify.designMode) return;
  var normalizedPath = window.location.pathname.replace(/\/+$/, "");
  var marketPath = getLocalizedMarketPath();
  var collectionsRoot =
    marketPath && marketPath !== "/"
      ? marketPath + "/collections"
      : "/collections";

  if (normalizedPath === "/collections" || normalizedPath === collectionsRoot) {
    window.location.replace(localizeStorefrontPath("/collections/all"));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".menu-trigger");
  const targets = document.querySelectorAll("[data-target-menu]");

  let activeMenu = null;

  function closeAll() {
    triggers.forEach((t) => t.classList.remove("active"));
    targets.forEach((t) => t.classList.remove("active"));
    activeMenu = null;
  }

  function openMenu(name) {
    const trigger = document.querySelector(`[data-trigger-menu="${name}"]`);
    const target = document.querySelector(`[data-target-menu="${name}"]`);

    if (!trigger || !target) return;

    closeAll();

    trigger.classList.add("active");
    target.classList.add("active");

    activeMenu = name;
  }

  triggers.forEach((trigger) => {
    const name = trigger.dataset.triggerMenu;

    // Hover
    trigger.addEventListener("mouseenter", () => {
      if (activeMenu !== name) {
        openMenu(name);
      }
    });

    // Click toggle
    trigger.addEventListener("click", () => {
      if (activeMenu === name) {
        closeAll();
      } else {
        openMenu(name);
      }
    });
  });

  // ออกจาก target แล้วปิด
  targets.forEach((target) => {
    target.addEventListener("mouseleave", () => {
      closeAll();
    });
  });
});

//---------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".accordion .accordion-head")
    .forEach(function (head) {
      head.addEventListener("click", function (event) {
        event.preventDefault();

        var accordion = head.closest(".accordion");
        var item = head.closest(".accordion-item");
        var content = item ? item.querySelector(".accordion-content") : null;
        if (!accordion || !item || !content) return;

        var activeHead = accordion.querySelector(".accordion-head.active");
        var isOpening = !head.classList.contains("active");

        if (activeHead && activeHead !== head) {
          activeHead.classList.remove("active");
          var activeItem = activeHead.closest(".accordion-item");
          var activeContent = activeItem
            ? activeItem.querySelector(".accordion-content")
            : null;
          if (activeContent) {
            activeContent.style.display = "none";
          }
        }

        if (isOpening) {
          head.classList.add("active");
          content.style.display = "block";
        } else {
          head.classList.remove("active");
          content.style.display = "none";
        }
      });
    });
});

//---------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  function syncHeaderScrollState() {
    var header = document.querySelector("header");
    if (!header) return;

    if (window.scrollY >= 25) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  }

  syncHeaderScrollState();
  window.addEventListener("scroll", syncHeaderScrollState, { passive: true });
});

//---------------------------------------------------

document.addEventListener("click", function (event) {
  var qtyBtn = event.target.closest(".cart-qty__btn");
  if (!qtyBtn) return;

  var cartItem = qtyBtn.closest(".cart-item");
  if (!cartItem) return;

  var input = cartItem.querySelector(".cart-qty__input");
  if (!input) return;

  var current = parseInt(input.value, 10);
  if (isNaN(current)) current = 0;

  if (qtyBtn.getAttribute("data-action") === "increase") {
    input.value = current + 1;
  } else {
    input.value = Math.max(0, current - 1);
  }

  var form = qtyBtn.closest("form");
  if (form) form.submit();
});

//---------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var cartSummaryTotal = document.querySelector(".cart-summary__total");

  function updateCartDisplayTotal() {
    if (!cartSummaryTotal) return;

    var itemTotals = Array.prototype.slice.call(
      document.querySelectorAll(".cart-item__total[data-money-cents]"),
    );

    if (!itemTotals.length) return;

    var centsList = itemTotals.map(function (item) {
      return Number(item.getAttribute("data-money-cents") || 0);
    });

    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.sumDisplayedAmounts ===
        "function" &&
      typeof window.MarmorisStorefrontCurrency.formatDisplayAmount ===
        "function"
    ) {
      return window.MarmorisStorefrontCurrency.sumDisplayedAmounts(
        centsList,
      ).then(function (displayAmount) {
        cartSummaryTotal.textContent =
          window.MarmorisStorefrontCurrency.formatDisplayAmount(displayAmount);
      });
    }

    var centsTotal = centsList.reduce(function (sum, cents) {
      return sum + cents;
    }, 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var withCurrencyFormat =
        window.Shopify.money_with_currency_format ||
        window.Shopify.money_format;
      cartSummaryTotal.textContent = window.Shopify.formatMoney(
        centsTotal,
        withCurrencyFormat,
      );
      return Promise.resolve();
    }

    cartSummaryTotal.textContent = (centsTotal / 100).toFixed(2);
    return Promise.resolve();
  }

  updateCartDisplayTotal();

  var cartForm = document.querySelector(".cart-form");
  if (!cartForm) return;

  var checkoutButton = cartForm.querySelector('button[name="checkout"]');
  if (!checkoutButton) return;
  var noteField = cartForm.querySelector('textarea[name="note"]');
  var discountField = cartForm.querySelector('input[name="discount"]');

  cartForm.addEventListener("submit", function (event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== "checkout") return;

    event.preventDefault();
    if (cartForm.dataset.checkoutSubmitting === "true") return;

    cartForm.dataset.checkoutSubmitting = "true";
    checkoutButton.disabled = true;

    var discountValue = discountField ? discountField.value.trim() : "";
    var formData = new FormData(cartForm);
    formData.delete("checkout");
    formData.delete("discount");

    fetch(localizeStorefrontPath("/cart"), {
      method: "POST",
      body: formData,
    })
      .catch(function () {
        return null;
      })
      .finally(function () {
        var checkoutUrl = localizeStorefrontPath("/checkout");
        if (discountValue) {
          checkoutUrl += "?discount=" + encodeURIComponent(discountValue);
        }
        window.location.href = checkoutUrl;
      });
  });
});

//---------------------------------------------------

if (window.Fancybox) {
  Fancybox.bind("[data-fancybox]", {});
}

//---------------------------------------------------

(function () {
  var section = document.querySelector("[data-recently-viewed]");
  if (!section) return;

  var wrapper = section.querySelector(".swiper-wrapper");
  if (!wrapper) return;

  var currentHandle = section.getAttribute("data-current-handle");
  var currentProductDataScript = section.querySelector(
    "[data-recently-product-data]",
  );
  var storageKey = "recentlyViewedProducts";
  var currentProductData = null;

  if (currentProductDataScript) {
    try {
      currentProductData = JSON.parse(
        currentProductDataScript.textContent || "{}",
      );
    } catch (e) {
      currentProductData = null;
    }
  }

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || "[]");
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (e) {
      return;
    }
  }

  function getStoredHandle(item) {
    if (!item) return "";
    if (typeof item === "string") return item;
    if (typeof item.handle === "string") return item.handle;
    return "";
  }

  function updateList(product) {
    var handle = getStoredHandle(product);
    if (!handle) return;

    var list = getList().filter(function (item) {
      return getStoredHandle(item) !== handle;
    });

    list.unshift(handle);
    setList(list.slice(0, 20));
  }

  function formatMoney(cents) {
    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.formatMoneySync === "function"
    ) {
      return window.MarmorisStorefrontCurrency.formatMoneySync(cents);
    }

    var amount = typeof cents === "number" ? cents : parseFloat(cents || 0);
    if (isNaN(amount)) amount = 0;

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var withCurrencyFormat =
        window.Shopify.money_with_currency_format ||
        window.Shopify.money_format;
      if (withCurrencyFormat) {
        return window.Shopify.formatMoney(amount, withCurrencyFormat);
      }
    }

    var locale = document.documentElement.lang || "th-TH";
    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "THB";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount / 100);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options;
    }
    var options = [];
    if (variant.option1 !== undefined && variant.option1 !== null) {
      options.push(variant.option1);
    }
    if (variant.option2 !== undefined && variant.option2 !== null) {
      options.push(variant.option2);
    }
    if (variant.option3 !== undefined && variant.option3 !== null) {
      options.push(variant.option3);
    }
    return options;
  }

  function getSelectedVariant(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var firstAvailable = variants.find(function (variant) {
      return !!variant.available;
    });
    return firstAvailable || variants[0] || null;
  }

  function buildQuickAddProductData(product, selectedVariant) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var images = Array.isArray(product.images)
      ? product.images.slice(0, 6)
      : [];
    var url =
      product.url ||
      (product.handle
        ? localizeStorefrontPath("/products/" + product.handle)
        : "#");
    var productSpecificTag = getProductSpecificTag(product);

    var payload = {
      id: product.id,
      title: product.title || "",
      url: url,
      product_specific_tag: productSpecificTag,
      options: product.options || [],
      selected_variant_id: selectedVariant ? selectedVariant.id : null,
      images: images,
      variants: variants.map(function (variant) {
        return {
          id: variant.id,
          available: variant.available,
          inventory_management: variant.inventory_management,
          inventory_policy: variant.inventory_policy,
          inventory_quantity: variant.inventory_quantity,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          options: buildVariantOptions(variant),
        };
      }),
    };

    return JSON.stringify(payload).replace(/<\//g, "<\\/");
  }

  function renderImageTag(src, title, className) {
    var normalizedSrc = normalizeImageSource(src);
    if (!normalizedSrc) return "";

    return (
      '<img class="product-card__image ' +
      className +
      '" src="' +
      escapeHtml(normalizedSrc) +
      '" alt="' +
      escapeHtml(title) +
      '" loading="lazy">'
    );
  }

  function normalizeImageSource(image) {
    if (!image) return "";
    if (typeof image === "string") return image;
    if (typeof image.src === "string") return image.src;
    if (typeof image.url === "string") return image.url;
    return "";
  }

  function getProductSpecificTag(product) {
    if (product && product.product_specific_tag) {
      return product.product_specific_tag;
    }

    if (
      product &&
      product.metafields &&
      product.metafields.custom &&
      product.metafields.custom.product_specific_tag
    ) {
      return product.metafields.custom.product_specific_tag;
    }

    return "";
  }

  function getProductFeaturesLabel(product) {
    if (product && product.product_features_label) {
      return product.product_features_label;
    }

    if (
      product &&
      product.metafields &&
      product.metafields.custom &&
      product.metafields.custom.product_features_label
    ) {
      return product.metafields.custom.product_features_label;
    }

    return "";
  }

  function renderFeatureLabel(src) {
    var normalizedSrc = normalizeImageSource(src);
    if (!normalizedSrc) return "";

    return (
      '<img class="product-features-label" src="' +
      escapeHtml(normalizedSrc) +
      '" alt="" loading="lazy">'
    );
  }

  function fetchRecentlyViewedCard(handle) {
    return fetch(
      localizeStorefrontPath(
        "/products/" + handle + "?section_id=recently-product-card",
      ),
    )
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        if (!html) return null;

        var doc = new DOMParser().parseFromString(html, "text/html");
        var renderedCard = doc.querySelector(
          "[data-recently-product-card] .product-card",
        );
        if (!renderedCard) return null;

        var slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.appendChild(renderedCard);

        if (
          window.MarmorisStorefrontCurrency &&
          typeof window.MarmorisStorefrontCurrency.enhancePrices === "function"
        ) {
          window.MarmorisStorefrontCurrency.enhancePrices(slide);
        }

        return slide;
      })
      .catch(function () {
        return null;
      });
  }

  function render(list) {
    if (!list.length) {
      section.style.display = "none";
      return;
    }

    wrapper.innerHTML = "";
    Promise.all(
      list.map(function (item) {
        var handle = getStoredHandle(item);
        if (!handle) return Promise.resolve(null);
        return fetchRecentlyViewedCard(handle);
      }),
    ).then(function (slides) {
      var renderedCount = 0;
      slides.forEach(function (slide) {
        if (!slide) return;
        wrapper.appendChild(slide);
        renderedCount += 1;
      });

      if (!renderedCount) {
        section.style.display = "none";
        return;
      }

      section.style.display = "";

      if (window.Swiper) {
        var swiperInstance = section.querySelector(".swiper")
          ? section.querySelector(".swiper").swiper
          : null;
        if (swiperInstance) swiperInstance.update();
      }
    });
  }

  if (currentProductData && currentProductData.handle) {
    updateList(currentProductData);
  } else if (currentHandle) {
    updateList(currentHandle);
  }

  var list = getList().filter(function (item) {
    var handle = getStoredHandle(item);
    return handle && handle !== currentHandle;
  });

  render(list.slice(0, 5));
})();

//---------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("search-drawer-btn");
  const drawer = document.getElementById("search-drawer-ele");

  if (!btn || !drawer) return;

  btn.addEventListener("click", function (e) {
    e.stopPropagation();
    drawer.classList.toggle("active");
  });

  drawer.addEventListener("click", function (e) {
    e.stopPropagation();
  });

  document.addEventListener("click", function () {
    drawer.classList.remove("active");
  });
});

//---------------------------------------------------

function initCartAlsoLikeRandom() {
  var section = document.querySelector(".cart-also-like");
  if (!section) return;

  var slides = Array.from(section.querySelectorAll(".swiper-slide"));
  if (slides.length <= 5) return;

  var shuffled = slides.sort(function () {
    return Math.random() - 0.5;
  });

  shuffled.forEach(function (slide, index) {
    if (index < 5) {
      slide.style.display = "";
    } else {
      slide.style.display = "none";
    }
  });
}

initCartAlsoLikeRandom();

var swiperElement = document.querySelector(".mySwiper-pd");
if (swiperElement && window.Swiper) {
  var swiper = new Swiper(".mySwiper-pd", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      325: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 8,
      },
    },
  });

  if (swiper && typeof swiper.update === "function") {
    swiper.update();
  }
}

//---------------------------------------------------
if (
  window.gsap &&
  window.SplitText &&
  document.querySelector(".our-story-banner")
) {
  if (
    window.ScrollTrigger &&
    typeof window.gsap.registerPlugin === "function"
  ) {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }

  var headtext01 = new SplitText(".our-story-banner h1 .row-1");
  var headtext02 = new SplitText(".our-story-banner h1 .row-2");

  var banner_animation = gsap.timeline({});

  banner_animation
    .from(headtext01.chars, {
      opacity: 0,
      ease: "sine.inout",
      y: 5,
      stagger: 0.07,
    })
    .from(
      headtext02.chars,
      { opacity: 0, ease: "sine.inout", y: 5, stagger: 0.07 },
      "<0.5",
    )
    .from(
      ".our-story-banner img",
      { duration: 0.7, opacity: 0, ease: "sine.inout", y: 40 },
      "<0.25",
    )
    .from(
      ".our-story-banner .breadcrumb",
      { duration: 0.5, opacity: 0, ease: "sine.inout", y: 20 },
      "<0.25",
    )
    .to("body , html", { overflow: "visible" });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-content .img-left",
        start: "top 80%",
        end: "bottom bottom",
      },
    })
    .from(
      ".our-story-content .img-left",
      { opacity: 0, y: 40, ease: "sine.inout", duration: 0.7 },
      "0.5",
    );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-content .img-right",
        start: "top 80%",
        end: "bottom bottom",
      },
    })
    .from(
      ".our-story-content .img-right",
      { opacity: 0, y: 40, ease: "sine.inout", duration: 0.7 },
      "0.5",
    );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-content",
        start: "20% 0%",
        end: "70% top",
        scrub: 1,
      },
    })
    .fromTo(
      ".our-story-content .video-wrapper",
      { clipPath: "circle(0% at center)" },
      { clipPath: "circle(100% at center)" },
    );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-content",
        start: "25% 0%",
        end: "80% top",
        toggleActions: "play none none reverse",
      },
    })
    .fromTo(
      ".our-story-content h2 , .our-story-content p",
      { color: "#000" },
      { color: "#fff", ease: "none" },
    )
    .from(".our-story-content .wrapper img", {
      opacity: 0,
      y: 40,
      ease: "sine.inout",
    });

  var ourStoryShopMobileQuery = window.matchMedia("(max-width: 991px)");
  var ourStoryShopImageFromTop = ourStoryShopMobileQuery.matches
    ? "-50px"
    : "-100px";
  var ourStoryShopImageToTop = ourStoryShopMobileQuery.matches
    ? "50px"
    : "100px";

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-shop",
        start: "top 100%",
        end: "60% top",
        scrub: 1,
      },
    })
    .fromTo(
      ".our-story-shop .left img",
      { top: ourStoryShopImageFromTop },
      { top: ourStoryShopImageToTop },
    )
    .fromTo(
      ".our-story-shop .right img",
      { bottom: "70%" },
      { bottom: "15%" },
      "<",
    );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-purpose .item-01",
        start: "top 70%",
        end: "bottom top",
      },
    })
    .from(".our-story-purpose .item-01", {
      y: "40px",
      opacity: 0,
      ease: "sine.inout",
    });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".our-story-purpose .item-02",
        start: "top 70%",
        end: "bottom top",
      },
    })
    .from(".our-story-purpose .item-02", {
      y: "40px",
      opacity: 0,
      ease: "sine.inout",
    });
}

document.addEventListener("DOMContentLoaded", function () {
  var mobileParallaxQuery = window.matchMedia("(max-width: 1023px)");
  var valuesItems = [];
  var ticking = false;

  function collectValuesItems() {
    valuesItems = [];

    document.querySelectorAll(".ss-our-values .item").forEach(function (item) {
      var bg = item.querySelector("img.bg");
      if (bg) valuesItems.push({ item: item, bg: bg });
    });
  }

  function resetValuesParallax() {
    valuesItems.forEach(function (entry) {
      entry.bg.style.transform = "translate3d(0, 0, 0)";
    });
  }

  function updateValuesParallax() {
    ticking = false;

    if (!mobileParallaxQuery.matches) {
      resetValuesParallax();
      return;
    }

    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;

    valuesItems.forEach(function (entry) {
      var rect = entry.item.getBoundingClientRect();
      var progress =
        (viewportHeight - rect.top) / (viewportHeight + rect.height);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var offset = (progress - 0.5) * 48;
      entry.bg.style.transform = "translate3d(0, " + offset + "%, 0)";
    });
  }

  function requestValuesParallaxUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateValuesParallax);
  }

  function handleValuesParallaxModeChange() {
    collectValuesItems();
    requestValuesParallaxUpdate();
  }

  collectValuesItems();
  requestValuesParallaxUpdate();

  window.addEventListener("scroll", requestValuesParallaxUpdate, {
    passive: true,
  });
  window.addEventListener("resize", requestValuesParallaxUpdate);
  window.addEventListener("orientationchange", requestValuesParallaxUpdate);

  if (typeof mobileParallaxQuery.addEventListener === "function") {
    mobileParallaxQuery.addEventListener(
      "change",
      handleValuesParallaxModeChange,
    );
  } else if (typeof mobileParallaxQuery.addListener === "function") {
    mobileParallaxQuery.addListener(handleValuesParallaxModeChange);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var mobileParallaxQuery = window.matchMedia("(max-width: 1023px)");
  var collectionItems = [];
  var ticking = false;

  function collectCollectionItems() {
    collectionItems = [];

    document
      .querySelectorAll(".index-collection-select .left")
      .forEach(function (item) {
        var bg = item.querySelector("img");
        if (bg) collectionItems.push({ item: item, bg: bg });
      });
  }

  function resetCollectionParallax() {
    collectionItems.forEach(function (entry) {
      entry.bg.style.transform = "translate3d(0, 0, 0)";
    });
  }

  function updateCollectionParallax() {
    ticking = false;

    if (!mobileParallaxQuery.matches) {
      resetCollectionParallax();
      return;
    }

    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;

    collectionItems.forEach(function (entry) {
      var rect = entry.item.getBoundingClientRect();
      var progress =
        (viewportHeight - rect.top) / (viewportHeight + rect.height);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var offset = (progress - 0.5) * 48;
      entry.bg.style.transform = "translate3d(0, " + offset + "%, 0)";
    });
  }

  function requestCollectionParallaxUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateCollectionParallax);
  }

  function handleCollectionParallaxModeChange() {
    collectCollectionItems();
    requestCollectionParallaxUpdate();
  }

  collectCollectionItems();
  requestCollectionParallaxUpdate();

  window.addEventListener("scroll", requestCollectionParallaxUpdate, {
    passive: true,
  });
  window.addEventListener("resize", requestCollectionParallaxUpdate);
  window.addEventListener("orientationchange", requestCollectionParallaxUpdate);

  if (typeof mobileParallaxQuery.addEventListener === "function") {
    mobileParallaxQuery.addEventListener(
      "change",
      handleCollectionParallaxModeChange,
    );
  } else if (typeof mobileParallaxQuery.addListener === "function") {
    mobileParallaxQuery.addListener(handleCollectionParallaxModeChange);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var mobileParallaxQuery = window.matchMedia("(max-width: 1023px)");
  var bannerEntries = [];
  var ticking = false;

  function collectBannerEntries() {
    bannerEntries = [];

    document
      .querySelectorAll(".collections-banner")
      .forEach(function (section) {
        var images = Array.prototype.slice.call(
          section.querySelectorAll("img.bg"),
        );
        if (images.length)
          bannerEntries.push({ section: section, images: images });
      });
  }

  function resetBannerParallax() {
    bannerEntries.forEach(function (entry) {
      entry.images.forEach(function (image) {
        image.style.transform = "translate3d(0, 0, 0)";
      });
    });
  }

  function updateBannerParallax() {
    ticking = false;

    if (!bannerEntries.length) return;

    if (!mobileParallaxQuery.matches) {
      resetBannerParallax();
      return;
    }

    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;

    bannerEntries.forEach(function (entry) {
      var rect = entry.section.getBoundingClientRect();
      var progress =
        (viewportHeight - rect.top) / (viewportHeight + rect.height);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var offset = (progress - 0.5) * 32;
      entry.images.forEach(function (image) {
        image.style.transform = "translate3d(0, " + offset + "%, 0)";
      });
    });
  }

  function requestBannerParallaxUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateBannerParallax);
  }

  function handleBannerParallaxModeChange() {
    collectBannerEntries();
    requestBannerParallaxUpdate();
  }

  collectBannerEntries();

  if (!bannerEntries.length) {
    resetBannerParallax();
    return;
  }

  requestBannerParallaxUpdate();

  window.addEventListener("scroll", requestBannerParallaxUpdate, {
    passive: true,
  });
  window.addEventListener("resize", requestBannerParallaxUpdate);
  window.addEventListener("orientationchange", requestBannerParallaxUpdate);

  if (typeof mobileParallaxQuery.addEventListener === "function") {
    mobileParallaxQuery.addEventListener(
      "change",
      handleBannerParallaxModeChange,
    );
  } else if (typeof mobileParallaxQuery.addListener === "function") {
    mobileParallaxQuery.addListener(handleBannerParallaxModeChange);
  }
});
